import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../utilities/axiosInstance";
import { filterRequest } from "../../utilities/apiManager";

let initialState = {
  isLoading: false,
  data: [],
  ownerDetails: null,
  itemsCount: 0,
  pages: 0,
  error: null
}

export const getOwners = createAsyncThunk(
  "owners/getOwners",
  async (args, thunkApi) => {
    try {
      const { page, size = 10, query } = args;
      const filter = filterRequest(args.filter);
      const { data } = await axiosInstance.get(
        `/owners/all?page=${page}&size=${size}&query=${query}${filter}`
      );
      return thunkApi.fulfillWithValue(data);
    } catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

const ownersSlice = createSlice({
  name: "owners",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getOwners.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getOwners.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data = payload.data?.data;
        state.itemsCount = payload.data?.itemsCount;
        state.pages = payload.data?.pages;
        state.error = null;
      })
      .addCase(getOwners.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message
      })
  }
});

export default ownersSlice.reducer;